const ExpiredNotice = () => {
    return (
      <div className="flex items-center my-5 mx-auto md:flex-col ">
        <span className="text-orange-500 text-1xl capitalize  mr-2">It's Now !!! </span>{" "}
        <p className="text-orange-500 text-sm">Waiting for host.</p>
      </div>
    );
  };

  export default ExpiredNotice